module.exports = __webpack_public_path__ + "images/elephant_ganjarelex-48398f216c96353e179dbda00c267e57.jpg";